import { FmImageCardActionsProps } from "domains/file-manager/components/FileManagerImage/Card/Actions";
import MenuItem from "domains/ui/components/Menu/MenuItem";

export type CardActionsImageCustomProps = {
  _never?: never;
};

export type CardActionsImageProps =
  FmImageCardActionsProps<CardActionsImageCustomProps>;

export default function CardActionsImage({
  asset,
  top,
  bottom,
  onActionClick,
}: CardActionsImageProps) {
  const assetId = asset?.id;
  const modelId = asset?.metadata.modelId;
  const hasPrompt = !!asset?.metadata.prompt;
  const canReuseImage = !["vectorization"].includes(asset?.metadata.type ?? "");

  if (!modelId && !canReuseImage && !hasPrompt) {
    return null;
  }

  return (
    <>
      {top}

      {modelId && (
        <MenuItem
          w="170px"
          iconId="Nav/Model/Outline"
          iconH="12px"
          internalLink={{
            pathname: "/images/new",
            query: {
              modelId,
            },
          }}
          onClick={() => onActionClick?.("useModel")}
          text="Model"
        />
      )}

      {canReuseImage && (
        <MenuItem
          w="170px"
          iconId="Nav/Image/Outline"
          iconH="12px"
          internalLink={{
            pathname: "/images/new",
            query: {
              importAssetId: assetId,
            },
          }}
          onClick={() => onActionClick?.("useImage")}
          text="Image"
        />
      )}

      {hasPrompt && (
        <MenuItem
          w="170px"
          iconId="Ui/Prompt"
          iconH="12px"
          internalLink={{
            pathname: "/images/new",
            query: {
              importPromptFromAssetId: assetId,
            },
          }}
          onClick={() => onActionClick?.("usePrompt")}
          text="Prompt"
        />
      )}

      {bottom}
    </>
  );
}
